import { Text } from '@/shared/ui/primitives';
import type { FC } from 'react';

interface FieldErrorProps {
  message?: string;
  id?: string;
}

export const FieldError: FC<FieldErrorProps> = ({ message, id }) =>
  message ? (
    <Text
      id={id}
      role="alert"
      variant="caption"
      weight="medium"
      style={{
        color: 'var(--shanti-danger)',
        paddingLeft: 22,
        paddingRight: 22,
        display: 'block',
        transform: 'translateY(-12px)', // tricky hack, but works
        marginBottom: 4,
      }}
    >
      {message}
    </Text>
  ) : null;
